import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import InvoiceType from 'src/models/InvoiceType';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Client from 'src/models/AP/Client';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import { ITableConfig } from 'src/components/common/table';
import CPNavBar from '../CPNavBar';
import FindClientDialog from  '../dialogs/FindClientDialog';
import TsdiClient from 'src/models/AP/Client';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import 'react-datepicker/dist/react-datepicker.css';
import './ClientMaintenancePage.scss';
import InvoiceTypeList from 'src/components/project/sections/InvoiceTypeList';
import ClientBillingInfo from 'src/models/ClientBillingInfo';
import { MdHistory } from 'react-icons/md';        // Material Design
import { createBrowserHistory } from 'history';

const ManageClientBilling = () => {
    const dispatch = useDispatch();
    const [invoiceTypeList, setInvoiceTypeList] = useState<InvoiceType[]>([]);
    const { get, post, put, response } = useFetch();
    const [selectedInvoiceTypes, setSelectedInvoiceTypes] = useState<InvoiceType[]>([]);
    const { reset: resetClientBillingForm, register: registerClientBillingForm, setValue, getValues, handleSubmit, formState, errors, control } = useForm();
    const { reset: resetSelectedClient, register: registerSelectedClient} = useForm();
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [clientInfo, setClientInfo] = useState<TsdiClientInfo>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [clientTypes, setClientTypes] = useState<{ code: number, description: string}[]>([]);
    const [clientBillingInfo, setClientBillingInfo] = useState<ClientBillingInfo>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [addingClient, setAddingClient] = useState<boolean>(false);
    const [chargBackupState, setChargeBackupState] = useState<boolean>(false);
    const [chargBackupAtCost, setChargBackupAtCost] = useState<boolean>(false);
    const [mileageDestination, setMileageDestination] = useState<boolean>(false);
    const [billByOptions, setBillByOptions] = React.useState<Array<{ value: number, label: string}>>(undefined);
    const [tsdiAccounts, setTsdiAccounts] = useState<Array<{ code: number, description: string}>>(undefined);
    const { isDirty } = formState;
    const history = createBrowserHistory();
    
    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clients) {
            const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
            if (!!storedClientNumber && !isNaN(Number(storedClientNumber))) {
                const clientToSelect = clients.find((c) => c.clientNumber === Number(storedClientNumber));
                if (!!clientToSelect) {
                    setSelectedClient(clientToSelect);
                }
            }
        }
    }, [clients]);

    useEffect(() => {
        if (!!clientInfo) {
            console.log('ClientInfo loaded logic goes here.');
        }
    }, [clientInfo]);

    useEffect(() => {
        if (!!addingClient) {
            showDialog(DialogList.FIND_CLIENT);
        }
    }, [addingClient]);

    useEffect(() => {
        if (!!selectedClient) {
            getClientInfo(selectedClient?.clientNumber);
            getClientBillingInfo(selectedClient?.clientNumber);
            getInvoiceTypes(selectedClient?.clientNumber);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    const getClientInfo = async (clientNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/info/${clientNumber}`);

        if (response.ok) {
            setClientInfo(result);
        } else {
            setClientInfo(new TsdiClientInfo());
            console.log('Unable to get client info data!');
        }
    };

    const getClientBillingInfo = async (clientNumber: number) => {        
        const result = await get(`/v1.0/ClientProjectMaintenance/client/billing/info/${clientNumber}`);

        if (response.ok) {
            console.log('Client Billing Info', result);
            setClientBillingInfo(result);
        }
    };

    const getBillbyOptions = async () => {
        const result = await get(`/v1.0/ClientProjectMaintenance/billing/billby/options`);

        if (response.ok) {
            if (!!result && result.length > 0) {
                setBillByOptions(result?.map((bbo: { code: number, description: string}) => {
                    return { value: bbo.code, label: bbo.description };
                }));
            }
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const getInvoiceTypes = async (clientNumber: number) => {
        const result = await get(`/v1.0/ClientProjectMaintenance/client/${clientNumber}/invoice/types`);

        if (response.ok) {
            setInvoiceTypeList(result);
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

/*     const addClient = async (payload: Client) => {
        let result = await post(`/v1.0/AccountsPayable/clients`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    }; */

    const updateClientBillingInfo = async (data: ClientBillingInfo) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/client/billing/info`, data);

        if (!response.ok) {
            alert('Unable to update client info data: ' + result);
        } else {
            setSelectedClient(selectedClient);
        }
    };

    const addTsdiClient = async (payload: Client) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/client`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    };

    const incrementClients = () => {
        if (!!fetchNextPage) {
            let newSearchOptions = _.cloneDeep(clientSearchOptions);
            newSearchOptions.incrementPageNumber();
            setClientSearchOptions(newSearchOptions);
        }
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log(history);
        acquireAuthTokenForTabEntry();
        setAddingClient(false);
        getClientTypes();
        getBillingAccounts();
        initializeClientSearchSettings();
        getCurrentMileageRate();
        getBillbyOptions();
        const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
        const storedClientName = localStorage.getItem('backOfficeSelectedClientName');
        if (!!storedClientNumber && !isNaN(Number(storedClientNumber)) && !!storedClientName) {
            setClientSearchTerm(storedClientNumber);
        }
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const acquireAuthTokenForTabEntry = () => {
        const jwtToken = localStorage.getItem('jwt');
        if (jwtToken) {
            localStorage.setItem('jwt', jwtToken);
        }
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);

        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);

        if (response.ok) {
            setClientTypes([]);
            setClientTypes(result);
        } else {
            setClientTypes([]);
            console.log('Unable to get client type data!');
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm && fieldValues.length > 0 ? fieldValues[0] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm && fieldValues.length > 1 ? fieldValues[1] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm && fieldValues.length > 2 ? fieldValues[2] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm && fieldValues.length > 3 ? fieldValues[3] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm && fieldValues.length > 4 ? fieldValues[4] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm && fieldValues.length > 5 ? fieldValues[5] : ''));
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm && fieldValues.length > 6 ? fieldValues[6] : ''));
                setClientSearchOptions(newClientSearchOptions);
            }
        }
    };

    const findClient = (addNewClient: boolean) => {
        if (!!addNewClient) {
            setAddingClient(true);
        } else {
            setAddingClient(false);
            showDialog(DialogList.FIND_CLIENT);
        }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const displayTitle = () => {
        const title = 'Client Billing Maintenance';

        return title;
    };

    const resetInvoiceTypeValues = (index: number) => {
        let rep = getValues().invoiceTypes;
        let newList = [...rep];

        for (let i = index; i < rep.length - 1; i++) {
            setValue(`invoiceTypes[${i}].id`, rep[i + 1].id);
        }
        setValue(`invoiceTypes[${newList.length - 1}].id`, 0);
        newList.splice(newList.length - 1, 1);

        setSelectedInvoiceTypes(newList);
    };

    const requiredTimesheets = [
        {id: 1, description: `Client's Form`},
        {id: 2, description: 'DLC Form'},
        {id: 3, description: 'Recap Form'}
    ];

    const displayRequiredTimesheets = () => {
        return (
            <div>
                {requiredTimesheets && requiredTimesheets?.map((rt, index) => {
                    return (
                        <div key={rt.id} style={{ whiteSpace: 'nowrap', borderBottom: '1px solid darkgrey', margin: '0px', padding: '0px' }}>
                            <RHFCheckbox
                                name={`requiredTimesheets[${index}]`}
                                register={registerClientBillingForm}
                                label={rt.description}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    const displayClientBillingSettings = () => {
        return (
            <>
            <div style={{display: 'flex', width: '100%' }}>
                <div style={{overflowX: 'hidden', border: 'solid rgb(99, 147, 193) 1px', height: '300px', width: '25%' }}>
                    <RHFLegend
                        title="Invoice Types"
                    />
                    <InvoiceTypeList
                        typeList={invoiceTypeList}
                        selectedTypeList={selectedInvoiceTypes}
                        getValues={() => getValues()}
                        resetValues={(i: number) => resetInvoiceTypeValues(i)}
                        register={registerClientBillingForm}
                        errors={errors}
                        control={control}
                        tsdiAccounts={tsdiAccounts}
                    />
                </div>
                <div style={{border: 'solid rgb(99, 147, 193) 1px', height: '300px', width: '75%' }}>
                    <div className="form-row" style={{ marginBottom: '0' }}>
                        <RHFInputBox
                            label={'Default Day Rate'}
                            labelOnLeft={true}
                            name={'dayRate'}
                            register={registerClientBillingForm}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '20%' }}
                        />
                        <RHFInputBox
                            label={'Mileage Rate:'}
                            labelOnLeft={true}
                            name={'mileageRate'}
                            register={registerClientBillingForm}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '20%' }}
                        />
                        <RHFInputBox
                            name="backupOfficeRate"
                            label="Backup Office Rate"
                            register={registerClientBillingForm}
                            errors={errors}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '20%' }}
                        />
                        <RHFInputBox
                            name="backupOfficePercent"
                            label="Backup Office Percent"
                            register={registerClientBillingForm}
                            errors={errors}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '20%' }}
                        />
                        <RHFInputBox
                            label={'Invoices Due:'}
                            labelOnLeft={true}
                            name={'invoiceDueDays'}
                            register={registerClientBillingForm}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '15%' }}
                        />
                    </div>
                    <div className="form-row" style={{ marginBottom: '0' }}>
                        <RHFSelect
                            label={`Invoice Supplement`}
                            name={`invoiceSupplement`}
                            register={registerClientBillingForm}
                            bodyStyle={{width: '45%', whiteSpace: 'nowrap'}}
                            options={[
                                { value: '0', label: 'None' },
                                { value: '1', label: 'Unit Summary' },
                                { value: '2', label: 'Client LM Summary' }
                            ]}
                            style={{width: '100%' }}
                        />
                        <RHFInputBox
                            name="invoiceFactor"
                            label="Invoice Factor"
                            register={registerClientBillingForm}
                            errors={errors}
                            type={'number'}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '30%' }}
                        />
                        <RHFSelect
                            label="Invoice Format"
                            name="invoiceFormat"
                            options={[
                                { value: 'A', label: 'A' },
                                { value: 'B', label: 'B' },
                                { value: 'C', label: 'C' },
                                { value: 'D', label: 'D' },
                                { value: 'E', label: 'E' },
                                { value: 'F', label: 'F' },
                                { value: 'G', label: 'G' },
                                { value: 'H', label: 'H' },
                                { value: 'I', label: 'I' },
                                { value: 'J', label: 'J' },
                                { value: 'K', label: 'K' },
                                { value: 'L', label: 'L' },
                                { value: 'M', label: 'M' },
                                { value: 'R', label: 'R' },
                            ]}
                            style={{width: '100%' }}
                            bodyStyle={{width: '30%', whiteSpace: 'nowrap'}}
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFSelect
                            label="Invoice Period"
                            name="invoicePeriod"
                            options={[
                                { value: 'W', label: 'Weekly' },
                                { value: 'S', label: 'Semi-Monthly' },
                                { value: 'M', label: 'Monthly' },
                            ]}
                            style={{width: '100%' }}
                            bodyStyle={{width: '40%', whiteSpace: 'nowrap'}}
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFSelect
                            label="Bill By"
                            name="billBy"
                            options={!!billByOptions ? billByOptions : [
                                { value: 'G', label: 'Day/Account' },
                                { value: 'Y', label: 'Day/Breakdown' },
                                { value: 'L', label: 'Day/Landman' },
                                { value: 'D', label: 'Day/Project' },
                                { value: 'E', label: 'Day/Subcode' },
                                { value: 'F', label: 'Day/Tract' },
                                { value: 'U', label: 'Day/AltSubcode' },
                                { value: 'K', label: 'Hour/Account' },
                                { value: 'Z', label: 'Hour/Breakdown' },
                                { value: 'M', label: 'Hour/Landman' },
                                { value: 'H', label: 'Hour/Project' },
                                { value: 'I', label: 'Hour/Subcode' },
                                { value: 'J', label: 'Hour/Tract' },
                                { value: 'V', label: 'Hour/AltSubcode' }
                            ]}
                            register={registerClientBillingForm}
                            errors={errors}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '28%' }}
                        />
                    </div>
                    <div className="form-row" style={{whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            name="arInvoiceGrouping"
                            label="A/R Invoice Grouping?"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFCheckbox
                            name="printPreparedDate"
                            register={registerClientBillingForm}
                            checked={!!clientBillingInfo?.preparedDate ? clientBillingInfo.preparedDate : false }
                            label={'Prepared Date on Invoice?'}
                            onClick={() => { clientBillingInfo.preparedDate = !clientBillingInfo.preparedDate; }}
                        />
                        <RHFCheckbox
                            name="clientLmEmailonInvoice"
                            register={registerClientBillingForm}
                            label={'Client LM E-mail on Invoice?'}
                        />
                        <RHFCheckbox
                            name="bopNameOnInvoice"
                            register={registerClientBillingForm}
                            label={'BOP Name on Invoice?'}
                        />
                    </div>
                    <div className="form-row" style={{ whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            name="mileageDestinationRequired"
                            register={registerClientBillingForm}
                            label={'Mileage Destination Required?'}
                            checked={mileageDestination}
                            onClick={() => { setMileageDestination(!mileageDestination); }}
                        />
                        <RHFCheckbox
                            name="mealreceiptsrequired"
                            register={registerClientBillingForm}
                            label={'Meal Receipts Required'}
                        />
                        <RHFCheckbox
                            name="unitEntryRequired"
                            label="Altsubcode Required?"
                            register={registerClientBillingForm}
                        />
                        <RHFCheckbox
                            name="turnkeyBilling"
                            label="Turnkey Billing?"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                    </div>
                    <div className="form-row" style={{ whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            name="billToOtherProject"
                            label="Bill To Other Project?"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFCheckbox
                            bodyStyle={{ width: '210px' }}
                            name="doNotExceedProject"
                            label="Do Not Exceed Project?"
                            labelStyle={{whiteSpace: 'nowrap'}}
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFCheckbox
                            name="breakdownOfficeExpenses"
                            register={registerClientBillingForm}
                            label={'Breakdown TSDI Office Expenses?'}
                        />
                        <RHFCheckbox
                            name="chargeTsdiOfficeExpenses"
                            register={registerClientBillingForm}
                            label={'Charge TSDI Office Expenses?'}
                        />
                    </div>
                    <div className="form-row" style={{ whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            name="flatDayRate"
                            register={registerClientBillingForm}
                            label={'Flat Day Rate (No Expenses)?'}
                        />
                        <RHFCheckbox
                            name="clientProspectNameOnTimeSheet"
                            register={registerClientBillingForm}
                            label={'Client Prospect Name on Time Sheet?'}
                        />
                        <RHFCheckbox
                            name="clientProspectNoOnTimeSheet"
                            register={registerClientBillingForm}
                            label={'Client Prospect No. on Time Sheet?'}
                        />
                    </div>
                    <div className="form-row" style={{ whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            name="chargeBackupPersonnel"
                            register={registerClientBillingForm}
                            checked={chargBackupState}
                            label={'Charge Backup Personnel?'}
                            onClick={() => { setChargeBackupState(!chargBackupState); }}
                        />
                        <RHFCheckbox
                            name="chargeBackupPersonnelAtCost"
                            register={registerClientBillingForm}
                            checked={chargBackupAtCost}
                            label={'Charge Backup Personnel at Cost?'}
                            onClick={() => { setChargBackupAtCost(!chargBackupAtCost); }}
                        />
                    </div>
                    <div className="form-row" style={{ whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            name="enterClientAccountNoOnTimeSheet"
                            label="Client Account No on Time Sheet?"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFCheckbox
                            name="enterClientAFENoOnTimeSheet"
                            label="Client AFE No. on Time Sheet?"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFCheckbox
                            name="roundDays"
                            label="Round Days on Backup/Office"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                    </div>
                    <div className="form-row" style={{ whiteSpace: 'nowrap', marginBottom: '0' }}>
                        <RHFCheckbox
                            bodyStyle={{ width: '340px' }}
                            name="printAFEStatusOnInvoiceCoverLetter"
                            label="Print AFE Status on Invoice/Cover?"
                            register={registerClientBillingForm}
                            errors={errors}
                        />
                        <RHFInputBox
                            name="totalAfeWarningPercentage"
                            label="Total AFE Warning %"
                            register={registerClientBillingForm}
                            errors={errors}
                            style={{width: '100%' }}
                            bodyStyle={{whiteSpace: 'nowrap', width: '20%' }}
                        />
                        <RHFSelect
                            label="Billing Frequency"
                            name={`billingFrequency`}
                            options={[
                                { value: '0', label: 'Semi-Monthly' },
                                { value: '1', label: 'Monthly' },
                                { value: '0', label: 'Bi-Monthly' },
                                { value: '1', label: 'Quarterly' },
                                { value: '0', label: 'Semi-Annual' },
                                { value: '1', label: 'Annual' },
                            ]}
                            register={registerClientBillingForm}
                            errors={errors}
                            style={{ width: '100%' }}
                            bodyStyle={{ width: '25%' }}
                        />
                    </div>
                </div>
            </div>
            <div className="form-row" style={{ width: '55vw', marginBottom: '0' }}>
                {/* <div style={{ display: 'flex' }}>
                    <FormRow>
                        <RHFInputBox name="invoiceTypeNumber" label="Number" register={register} errors={errors} />
                        <RHFInputBox name="invoiceTypeDescription" label="Invoice Description" register={register} errors={errors} />
                        <RHFInputBox name="invoiceTypeAccount" label="Invoice Account" register={register} errors={errors} />
                    </FormRow>

                    <FormRow style={{ marginTop: '.5rem' }}>
                        <Button text="Add" />
                        <Button text="Delete" />
                        <Button text="Edit" />
                    </FormRow>
                </div> */}
                <div>
                    <FormRow style={{ marginTop: '.5rem' }}>
                        <div style={{padding: '2px', whiteSpace: 'nowrap', border: 'solid 1px'}}><label>Required Time Sheets</label></div>
                    </FormRow>
                </div>
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <div style={{width: '25%', borderTop: '1px solid grey'}}>
                    {displayRequiredTimesheets()}
                </div>
                <div style={{width: '75%', borderTop: '1px solid grey'}}>
                    <div className="project-billing mrg-top mrg-btm">
                        <div className={'project-billing folder-label-border'}>
                            <label className={'project-billing folder-label'} htmlFor="currentInstructions">Billing Instructions</label>
                        </div>
                        <RHFTextArea
                            name="currentInstructions"
                            register={registerClientBillingForm}
                            errors={errors}
                            style={{resize: 'none', border: 'solid black 1px', width: '100%', height: '11rem'}}
                        />
                    </div>
                </div>
            </div>
            </>
        );
    };

/*     const displayClientBillingInfo = () => {
        return (
            <>
                <RHFLegend title="Client Billing" />
                    <div className="flex-space__between mrg-btm">
                        <FormRow className="flex-space__between" style={{whiteSpace: 'nowrap'}}>
                            <div className="input-resize">
                                <RHFInputBox name="dayRate" label="Default Day Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="mileageRate" label="Mileage Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="backupRate" label="Backup Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox defaultVal="D" name="invoiceformat" label="Invoice Format" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Period"
                                    name="invoicePeriod"
                                    options={[
                                        { value: 'Weekly', label: 'Weekly' },
                                        { value: 'semiMonthly', label: 'Semi-Monthly' },
                                        { value: 'monthly', label: 'Monthly' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                    </div>
                    <div>
                        <FormRow className="flex-space__between" style={{whiteSpace: 'nowrap'}}>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Supplement"
                                    name="invoiceSupplement"
                                    options={[
                                        { value: 'None', label: 'None' },
                                        { value: 'Unit Summary', label: 'Unit Summary' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Bill By"
                                    name="billBy"
                                    options={!!billByOptions ? billByOptions : [
                                        { value: 'G', label: 'Day/Account' },
                                        { value: 'Y', label: 'Day/Breakdown' },
                                        { value: 'L', label: 'Day/Landman' },
                                        { value: 'D', label: 'Day/Project' },
                                        { value: 'E', label: 'Day/Subcode' },
                                        { value: 'F', label: 'Day/Tract' },
                                        { value: 'U', label: 'Day/AltSubcode' },
                                        { value: 'K', label: 'Hour/Account' },
                                        { value: 'Z', label: 'Hour/Breakdown' },
                                        { value: 'M', label: 'Hour/Landman' },
                                        { value: 'H', label: 'Hour/Project' },
                                        { value: 'I', label: 'Hour/Subcode' },
                                        { value: 'J', label: 'Hour/Tract' },
                                        { value: 'V', label: 'Hour/AltSubcode' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                    </div>
                    <div style={{ borderTop: '1px solid grey', borderBottom: '1px solid grey' }}>
                        <div className="mrg-top mrg-btm">
                            <RHFTextArea label="Billing Instructions" name="currentInstructions" register={register} errors={errors} />
                        </div>
                    </div>
            </>

        );
    };
 */

    const onSaveChanges = () => {
        if (isDirty) {
            const billingFormData = getValues();
            const keys = Object.keys(billingFormData.invoiceTypes);
            const keyToRemove = keys.find((k) => k === '${index]');
            delete billingFormData.invoiceTypes[keyToRemove];
            const updateInvoiceTypes = new Array<InvoiceType>();
            for (let key in keys) {
                if (keys.hasOwnProperty(key)) {
                    if (!!billingFormData.invoiceTypes[key]?.code) {
                        const invoiceType = { number: !isNaN(Number(billingFormData.invoiceTypes[key]?.number)) ? Number(billingFormData.invoiceTypes[key]?.number) : -1,
                            code: Number(billingFormData.invoiceTypes[key].code), description: billingFormData.invoiceTypes[key].description };
                        updateInvoiceTypes.push(invoiceType as InvoiceType);
                    }
                }
            }
            const rqtKeys = Object.keys(billingFormData.invoiceTypes);
            const updateRequiredTimesheets = new Array<{ code: string, description: string}>();
            for (let rtkey in rqtKeys) {
                if (rqtKeys.hasOwnProperty(rtkey)) {
                    if (billingFormData.requiredTimesheets[rtkey] !== undefined) {
                        const timeSheet = { code: !isNaN(Number(rtkey)) ? (Number(rtkey) + 1).toString() : '-1',
                            description: billingFormData.requiredTimesheets[rtkey] === true ? 'Y' : 'N' };
                        updateRequiredTimesheets.push(timeSheet);
                    }
                }
            }
            const payload = new ClientBillingInfo();
            payload.clientNumber = selectedClient?.clientNumber;
            payload.id = clientBillingInfo?.id;
            payload.invoiceTypes = updateInvoiceTypes;
            payload.requiredTimesheets = updateRequiredTimesheets;
            payload.dayRate = !!billingFormData?.dayRate && !isNaN(Number(billingFormData.dayRate)) ? Number(billingFormData.dayRate) : null;
            payload.mileageRate = !!billingFormData.mileageRate && !isNaN(Number(billingFormData.mileageRate)) ? Number(billingFormData.mileageRate) : null;
            payload.backupRate = !!billingFormData.backupOfficeRate && !isNaN(Number(billingFormData.backupOfficeRate)) ? Number(billingFormData.mileageRate) : null;
            payload.chargeBpPercentage = !!billingFormData.backupOfficePercent && !isNaN(Number(billingFormData.backupOfficePercent)) ? Number(billingFormData.backupOfficePercent) : null;
            payload.invoiceDueDays = !!billingFormData.invoiceDueDays && !isNaN(Number(billingFormData.invoiceDueDays)) ? Number(billingFormData.invoiceDueDays) : null;
            payload.superFee = !!billingFormData.invoiceSupplement && !isNaN(Number(billingFormData.invoiceSupplement)) ? Number(billingFormData.invoiceSupplement) : null;
            payload.invoiceFactor = !!billingFormData.invoiceFactor && !isNaN(Number(billingFormData.invoiceFactor)) ? Number(billingFormData.invoiceFactor) : null;
            payload.invoiceFormat = billingFormData.invoiceFormat;
            payload.invoicePeriod = billingFormData.invoicePeriod;
            payload.billBy = billingFormData.billBy;
            payload.preparedDate = billingFormData.printPreparedDate;
            payload.emailInvoice = billingFormData.clientLmEmailonInvoice;
            payload.nameOnInvoice = billingFormData.bopNameOnInvoice;
            payload.mealReceipt = billingFormData.mealreceiptsrequired;
            payload.requireMileageDest = billingFormData.mileageDestinationRequired;
            payload.chargeBackup = billingFormData.chargeBackupPersonnel;
            payload.chargeBpAtCost = billingFormData.chargeBackupPersonnelAtCost;
            payload.officeBreakdown = billingFormData.breakdownOfficeExpenses;
            payload.chargeOp = billingFormData.chargeTsdiOfficeExpenses;
            payload.flatRate = billingFormData.flatDayRate;
            payload.enterClProspectName = billingFormData.clientProspectNameOnTimeSheet;
            payload.enterClProspectNo = billingFormData.clientProspectNoOnTimeSheet;
            payload.isTurnkeyBilling = billingFormData.turnkeyBilling;
            payload.billOtherProspect = billingFormData.billToOtherProject;
            payload.groupInvoices = billingFormData.arInvoiceGrouping;
            payload.altSubCodeRequired = billingFormData.unitEntryRequired;
            payload.enterClAccountNo = billingFormData.enterClientAccountNoOnTimeSheet;
            payload.enterClAfeNo = billingFormData.enterClientAFENoOnTimeSheet;
            payload.roundDays = billingFormData.roundDays;
            payload.printAfeStatus = billingFormData.printAFEStatusOnInvoiceCoverLetter;
            payload.afeWarningPercentage = !!billingFormData.totalAfeWarningPercentage &&
                !isNaN(Number(billingFormData.totalAfeWarningPercentage)) ? Number(billingFormData.totalAfeWarningPercentage) : null;
            payload.invoiceFrequency = billingFormData.billingFrequency;
            payload.currentInstructions = billingFormData.currentInstructions;
            payload.billBy = billingFormData.billBy;
            payload.mode = 0; // Hard-coded for now. 1 is reserved for "Environmental" billing which is not currently operational
            updateClientBillingInfo(payload);
        }
    };

    useEffect(() => {
        if (!!clientBillingInfo) {
            populateClientBillingForm();
            if (!!clients && clients?.length > 0) {
                if (selectedClient !== undefined) {
                    resetSelectedClient({ displayClientNumber: selectedClient?.clientNumber, displayClientName: selectedClient?.clientName });
                }
            }
        }
    }, [clientBillingInfo]);

    const displayHeading2 = () => {
        const title = 'Client Billing Settings';

        return title;
    };

    const onSubmit = () => {
        alert ('onSubmit not implemented');
    };

    const moveToNextRecord = () => {
        alert ('onSubmit not implemented');
    };

    const moveToPreviousRecord = () => {
        alert ('onSubmit not implemented');
    };

    const moveToLastRecord = () => {
        alert ('onSubmit not implemented');
    };

    const moveToFirstRecord = () => {
        alert ('onSubmit not implemented');
    };

    const populateClientBillingForm = () => {
        const billingForm = {
            dayRate: clientBillingInfo.dayRate,
            mileageRate: clientBillingInfo.mileageRate,
            billBy: clientBillingInfo.billBy,
            invoiceDueDays: clientBillingInfo.invoiceDueDays,
            printPreparedDate: clientBillingInfo.preparedDate,
            backupOfficeRate: clientBillingInfo.backupRate,
            backupOfficePercent: clientBillingInfo.chargeBpPercentage,
            chargeBackupPersonnel: clientBillingInfo.chargeBackup,
            clientLmEmailonInvoice: clientBillingInfo.emailInvoice,
            invoiceSupplement: clientBillingInfo.superFee,
            invoiceFormat: clientBillingInfo.invoiceFormat,
            invoicePeriod: clientBillingInfo.invoicePeriod,
            currentInstructions: clientBillingInfo.currentInstructions,
            requiredTimesheets: clientBillingInfo.requiredTimesheets.map((rt) => { return(rt.description === 'Y' ? true : false); })
        };
        setChargeBackupState(clientBillingInfo.chargeBackup);
        resetClientBillingForm(billingForm);
    };

    const renderClientBillingToggles = () => {
        return (
         <>
            <div className="form-row" style={{width: '100%', borderTop: '1px solid grey', borderBottom: '1px solid grey', marginBottom: '0' }}>
                <RHFInputBox
                    name="dunsNo"
                    label="DUNS No."
                    register={registerClientBillingForm}
                    errors={errors}
                />
                <RHFInputBox
                    name="contactName"
                    label="Contact Name"
                    register={registerClientBillingForm}
                    errors={errors}
                />
                <RHFInputBox
                    name="remitDept"
                    label="Remit Dept."
                    register={registerClientBillingForm}
                    errors={errors}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    name="contactPhone"
                    label="Contact Phone"
                    register={registerClientBillingForm}
                    errors={errors}
                />
                <RHFInputBox
                    name="apWebsite"
                    label="A/P Website"
                    register={registerClientBillingForm}
                    errors={errors}
                />
                <RHFInputBox
                    name="contactEmail"
                    label="Contact Email"
                    register={registerClientBillingForm}
                    errors={errors}
                />
            </div>
         </>   
        );
    };

    return (
        <div>
            <CPNavBar/>
            <ClientProjectSearch
                setSelectedClient={setSelectedClient}
                clients={clients}
                size={4}
            />
            <div id={'ClientBillingPage'} style={{margin: '0 auto', maxWidth: '68vw', display: 'flex', justifyContent: 'center'}}>
                <form id="clientInfoForm" onSubmit={handleSubmit(onSubmit)}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <div style={{display: 'flex'}}>
                                                <RHFInputBox
                                                    name={'displayClientNumber'}
                                                    bodyStyle={{width: '30%'}}
                                                    style={{width: '100%'}}
                                                    register={registerSelectedClient}
                                                />
                                                <RHFInputBox
                                                    name={'displayClientName'}
                                                    bodyStyle={{width: '100%'}}
                                                    style={{width: '100%'}}
                                                    register={registerSelectedClient}
                                                />
                                            </div>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(false)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToFirstRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Save Changes"
                                                reactIcon={FaRegSave}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => onSaveChanges()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastRecord}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Instruction History"
                                                reactIcon={MdHistory}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                        </div>                                    
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{maxWidth: '81vw'}}>
                                        {displayClientBillingSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <div style={{ width: '100%' }}>
                                            {renderClientBillingToggles()}
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
            <FindClientDialog 
                dialogName={DialogList.FIND_CLIENT} 
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                incrementClients={incrementClients}
                addNewClient={addingClient}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                onAddNewClient={addTsdiClient}
                clientTypes={clientTypes}
            />
        </div>
    );
};

export default ManageClientBilling;


// WEBPACK FOOTER //
// ./src/components/client-project/pages/ManageClientBilling.tsx